export const CAR_SKIP_OWNER_PIN = "carSkipOwnerPin";

export const buildCarPaymentSession = (row) => {
  const kind = row?.enrollment_kind === "in_escrow" ? "in_escrow" : "post_close";
  const owner = String(row?.owner_name || "").trim();
  const [firstName, ...rest] = owner.split(" ");
  const phone = row?.phone || "";

  return {
    enrollment: {
      payment_plan: row?.quoted_payment_plan || "car_5yr",
      revenue_share_choice: row?.quoted_revenue_share_choice || "keep",
      payment_timing:
        kind === "post_close" ? "client_pays_now" : row?.payment_timing || "",
      car_agent_property_id: Number(row?.id),
      car_agent_property_ids: [Number(row?.id)],
    },
    prefill: {
      enrollment_kind: kind,
      signup_method: "standard",
      email: row?.email || "",
      phone,
      phone1: phone,
      address: row?.address_line || "",
      city: row?.city || "",
      state: row?.state || "",
      zip: row?.zip || "",
      first_name: kind === "in_escrow" ? "" : firstName || "",
      last_name: kind === "in_escrow" ? "" : rest.join(" "),
      first_owner_first_name: kind === "in_escrow" ? "" : firstName || "",
      first_owner_last_name: kind === "in_escrow" ? "" : rest.join(" "),
      escrow_officer_name: row?.escrow_officer_name || "",
      escrow_officer_email: row?.escrow_officer_email || "",
      estimated_close_of_escrow: row?.estimated_close_of_escrow || "",
    },
  };
};

// True while a CAR agent is creating a client whose property is in escrow.
// Those buyers are never ID verified.
export const isCarInEscrowEnrollment = () => {
  try {
    const prefill = JSON.parse(localStorage.getItem("carPortfolioPrefill") || "null");
    return prefill?.enrollment_kind === "in_escrow";
  } catch {
    return false;
  }
};

export const rememberCarInEscrowPinSkip = () => {
  try {
    const prefill = JSON.parse(localStorage.getItem("carPortfolioPrefill") || "{}");
    if (prefill?.enrollment_kind === "in_escrow") {
      sessionStorage.setItem(CAR_SKIP_OWNER_PIN, "1");
    }
  } catch {
    // ignore a bad prefill payload
  }
};

// A C.A.R. (RE) agent goes straight past the "Owner Verified" list to the next
// step, in Add Client, resume signup and Add Property alike. Admin create-user,
// homeowner signup and other service providers keep the screen.
export const skipCarOwnerVerifiedPage = ({
  isServiceProvider = false,
  completeProtectionOnly = false,
  enrollmentKind = null,
} = {}) =>
  Boolean(isServiceProvider) &&
  (Boolean(completeProtectionOnly) || enrollmentKind === "in_escrow");

export const shouldSkipCarOwnerPin = () => {
  if (sessionStorage.getItem(CAR_SKIP_OWNER_PIN) === "1") {
    return true;
  }
  try {
    const prefill = JSON.parse(localStorage.getItem("carPortfolioPrefill") || "{}");
    return (
      localStorage.getItem("signup_source") === "car" &&
      prefill?.enrollment_kind === "in_escrow"
    );
  } catch {
    return false;
  }
};

export const carPortfolioAction = (row) => {
  if (row?.action === "closing_pending") {
    return {
      label: "View closing",
      status: row?.owner_consented_at
        ? "Buyer authorized"
        : "Enrolled — due at closing",
      enroll: false,
    };
  }
  if (row?.action === "resend_owner_invite") {
    return { label: "Resend invitation", status: null, enroll: false, resend: true };
  }
  if (row?.action === "continue_enrollment") {
    return { label: "Continue", status: null, enroll: true };
  }
  if (row?.action === "turn_on_protection") {
    return { label: "Turn On Protection", status: null, enroll: true };
  }
  return { label: "View Details", status: null, enroll: false };
};

const PAID_ROW_STATUSES = ["active", "awaiting_acceptance", "expired"];

// The Clients list shows who pays only once it is settled: the closing invoice
// exists (View closing) or the property was paid. A row still enrolling has
// just its "Currently in escrow" tag.
export const carClosingPayerTag = (row) =>
  row?.action === "closing_pending" || PAID_ROW_STATUSES.includes(row?.status)
    ? carClosingPayer(row)
    : null;

// Who pays an in-escrow enrollment at closing, so the agent can tell the rows apart (card 3853).
export const carClosingPayer = (row) => {
  if (row?.enrollment_kind !== "in_escrow") {
    return null;
  }
  if (row?.payment_timing === "buyer_pays_at_closing") {
    return {
      tag: "Buyer pays at closing",
      payment: "Buyer pays at closing through escrow",
      note: "The buyer pays at closing through escrow.",
      className: "bg-amber-50 text-amber-800",
    };
  }
  if (row?.payment_timing === "bill_at_closing") {
    return {
      tag: "You pay at closing",
      payment: "Bill me at closing",
      note: "The amount is taken from your commission at closing.",
      className: "bg-sky-50 text-sky-800",
    };
  }
  return null;
};
